import { getScriptData } from './utils/utils.js';

const useDarkTheme = window.localStorage.getItem('selected-theme') ? window.localStorage.getItem('selected-theme') === 'dark' : window.matchMedia('(prefers-color-scheme: dark)').matches;
if (useDarkTheme) {
	document.documentElement.setAttribute('data-bs-theme', 'dark');
}

const { keepaliveUrl, sessionTimeout } = getScriptData((import.meta as any).url) as {
	keepaliveUrl: string;
	sessionTimeout: number;
};

if (keepaliveUrl && sessionTimeout > 0) {
	const interval = sessionTimeout / 2;

	window.setInterval(() => {
		fetch(keepaliveUrl)
			.then((response) => {
				if (!response.ok) {
					console.warn(`[Session] Heartbeat fehlgeschlagen. Status: ${response.status}`);
				}
			})
			.catch((err) => {
				console.error('[Session] Netzwerkfehler beim Heartbeat-Ping:', err);
			});
	}, interval);
}
